import { render, staticRenderFns } from "./layoutExample.vue?vue&type=template&id=316e791c&scoped=true"
import script from "./layoutExample.vue?vue&type=script&lang=js"
export * from "./layoutExample.vue?vue&type=script&lang=js"
import style0 from "./layoutExample.vue?vue&type=style&index=0&id=316e791c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316e791c",
  null
  
)

export default component.exports